import { session } from '@/composables/useSession'

export function openSupport() {
  if (session.features.newZ2MessagingWidget) return window.Z2MessagingWidget.open()
  window.__z2SunCoWidgetRef?.show()
}
